import { useEffect, useState } from "react";
const FileViewer = ({ fileUrl }: { fileUrl: string }) => {
  const [fileContent, setFileContent] = useState<React.ReactNode>(null);
  useEffect(() => {
    const fetchFileContent = async () => {
      const fileExtension = fileUrl.split(".").pop()?.toLowerCase();
      if (fileExtension === "txt") {
        try {
          const response = await fetch(fileUrl);
          const text = await response.text();
          setFileContent(
            <pre className="whitespace-pre-wrap break-words">{text}</pre>
          );
        } catch (error) {
          setFileContent(<p>Erro ao carregar o arquivo de texto.</p>);
        }
      } else if (
        fileExtension === "jpg" ||
        fileExtension === "jpeg" ||
        fileExtension === "png"
      ) {
        setFileContent(
          <img
            src={fileUrl}
            alt="Imagem do arquivo"
            className="w-full h-auto"
          />
        );
      } else {
        setFileContent(
          <iframe
            src={`https://docs.google.com/viewer?embedded=true&url=${encodeURIComponent(
              fileUrl
            )}`}
            className="w-full h-[600px] border rounded-md shadow-sm bg-white"
            frameBorder="0"
          />
        );
      }
    };
    fetchFileContent();
  }, [fileUrl]);
  return <div className="p-4 bg-gray-100 rounded-b-lg">{fileContent}</div>;
};
export default FileViewer;
